import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

/** Shared state so AppComponent and pages can coordinate the vendor shell sidebar. */
@Injectable({ providedIn: 'root' })
export class VendorSideMenuService {
  readonly isOpen = signal(false);
  /** When true, child pages may show a menu button (shell sets from layout). */
  readonly showMenuButton = signal(false);

  private readonly toggleMenu$ = new Subject<void>();

  setOpen(open: boolean): void {
    this.isOpen.set(open);
  }

  setShowMenuButton(show: boolean): void {
    this.showMenuButton.set(show);
  }

  requestToggle(): void {
    this.toggleMenu$.next();
  }

  onToggleMenu() {
    return this.toggleMenu$.asObservable();
  }
}
